module.exports = __webpack_public_path__ + "83eaaf1472560f8e3a84e1a339c015c3.fbx";